module.exports = __webpack_public_path__ + "img/thumbnail_WesternChimpanzee_j_albino.b2446b07.png";